// Copyright (c) 2016 Deere & Company

import * as partReturnActions from '../../actions-list';
import * as userActions from '../../../user/actions-list';
import Facets, {getDefaultState} from '../state/facets';
import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';
import moment from 'moment';
import {updateList} from '../../../shared/services/list-selections';

const actions = {
    ...partReturnActions,
    ...userActions
};

const resetAllFacets = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.defaultDealerAccounts
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.defaultDealerAccounts
            }
        },
        partReturnStatusesFacet: {
            selectedStatuses: {
                $set: action.defaultStatuses
            }
        },
        requestDateFacet: {
            $merge: {
                dateRange: {
                    from: moment.utc().subtract(action.numberOfDays, 'days').startOf('day')
                        .valueOf(),
                    to: moment.utc().endOf('day').valueOf()
                }
            }
        },
        requestTypes: {
            allowedTypes: {
                $set: action.allowedRequestTypes
            },
            selectedTypes: {
                $set: action.allowedRequestTypes
            }
        }
    });

const toggleDealerAccountFacetItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const updateAllowedPartRequestTypes = (state, action) =>
    Facets.update(state, {
        requestTypes: {
            allowedTypes: {
                $set: action.allowedTypes
            }
        }
    });

const updateIsInitialLoad = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: false
            }
        }
    });

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const updateSelectedPartRequestType = (state, action) =>
    Facets.update(state, {
        requestTypes: {
            selectedTypes: {
                $set: updateList(
                    action.requestType,
                    action.isSelected,
                    'key',
                    state.requestTypes.selectedTypes
                )
            }
        }
    });

const updateSelectedPartRequestTypes = (state, action) =>
    Facets.update(state, {
        requestTypes: {
            selectedTypes: {
                $set: action.requestTypes
            }
        }
    });

const updateDealerAccountItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                selectedDealers: action.allowedDealers
            }
        }
    });

const updateReturnStatusItems = (state, action) =>
    Facets.update(state, {
        partReturnStatusesFacet: {
            $merge: {
                isInitialLoad: false,
                selectedStatuses: action.allowedStatuses
            }
        }
    });

const toggleReturnStatusItems = (state, action) => {

    const updatedSelectedReturnStatus = state.partReturnStatusesFacet.selectedStatuses.length ? [] : action.allowedStatuses;

    return Facets.update(state, {
        partReturnStatusesFacet: {
            $merge: {
                isInitialLoad: false,
                selectedStatuses: updatedSelectedReturnStatus
            }
        }
    });

};

const updateReturnStatusFacetItem = (state, action) =>
    Facets.update(state, {
        partReturnStatusesFacet: {
            selectedStatuses: {
                $set: updateList(
                    action.returnStatus,
                    action.isSelected,
                    'key',
                    state.partReturnStatusesFacet.selectedStatuses
                )
            }
        }
    });

const updateAllPartRequestsDateRangeFacet = (state, action) =>
    Facets.update(state, {
        requestDateFacet: {
            $merge: {
                dateRange: action.dateRange,
                isInitialLoad: false
            }
        }
    });

const updateDefaultRequestDate = (state, action) =>
    Facets.update(state, {
        requestDateFacet: {
            $merge: {
                dateRange: {
                    from: moment.utc().subtract(action.numberOfDays, 'days').startOf('day')
                        .valueOf(),
                    to: moment.utc().endOf('day').valueOf()
                },
                numberOfDays: action.numberOfDays
            }
        }
    });

const updateDealers = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

const updatePartRequestStatus = state =>
    Facets.update(state, {
        partReturnStatusesFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_ALL_PART_REQUESTS_FILTERS]: resetAllFacets,
        [actions.SELECT_ALL_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEMS]: updateDealerAccountItems,
        [actions.SELECT_ALL_PART_REQUESTS_DEFAULT_REQUEST_DATE]: updateDefaultRequestDate,
        [actions.SELECT_ALL_PART_REQUESTS_RETURN_STATUS_FACET_ITEMS]: updateReturnStatusItems,
        [actions.TOGGLE_ALL_PART_REQUESTS_RETURN_STATUS_FACET_ITEMS]: toggleReturnStatusItems,
        [actions.TOGGLE_ALL_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEMS]: toggleDealerAccountFacetItems,
        [actions.UPDATE_ALL_PART_REQUESTS_ALLOWED_REQUEST_TYPES]: updateAllowedPartRequestTypes,
        [actions.UPDATE_ALL_PART_REQUESTS_IS_INITIAL_LOAD]: updateIsInitialLoad,
        [actions.UPDATE_ALL_PART_REQUESTS_REQUEST_DATE_RANGE_FACET]: updateAllPartRequestsDateRangeFacet,
        [actions.UPDATE_ALL_PART_REQUESTS_RETURN_STATUS_FACET_ITEM]: updateReturnStatusFacetItem,
        [actions.UPDATE_ALL_PART_REQUESTS_DEALER_ACCOUNT_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.UPDATE_ALL_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEM]: updateDealerAccountFacetItem,
        [actions.UPDATE_ALL_PART_REQUESTS_SELECTED_REQUEST_TYPE]: updateSelectedPartRequestType,
        [actions.UPDATE_ALL_PART_REQUESTS_SELECTED_REQUEST_TYPES]: updateSelectedPartRequestTypes,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_PART_RETURNS_STATUS]: updatePartRequestStatus,
        [actions.UPDATE_USER_PREFERENCES_ALL_PART_RETURNS_STATUS]: updatePartRequestStatus
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/reducers/facets.js